<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>4LNG Second Edition: Structure, Function, and Information Processing - Downloads and Resources</h3>
      
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4>Teacher Presentations</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F4LNG-2E_Activities_1-5_08262024.zip?alt=media&token=b0ff7965-f383-4c9b-9205-5f56e868c0a1" target="_blank">Teacher Presentations: Activities 1 - 5</a> - Updated 8/26/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1jmuoHHdv_feYv3tO-CSOl5AmpkfsfZAeVLcb91ISQVg/copy" target="_blank">4LNG Second Edition: Structure, Function, and Information Processing Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1P_KtIsCHXKzmLHXtqAaVw423lYNzKqLz/view" target="_blank">4LNG Second Edition: Structure, Function, and Information Processing Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1vaMD5tJrlumnZG6Tlevuubw2TmJhMEqLN66_Tjcw6RI/copy" target="_blank">4LNG Second Edition: Structure, Function, and Information Processing Student Journal - SPANISH</a></li>
        </ul>

      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1Xz88Q5bCd2dXQZulZ40Y9enq3qTnAyz6VXZBCj5gILU/copy" target="_blank">Outside/Inside Cartoon Strip</a></li>
          <li><a href="https://docs.google.com/presentation/d/14wrrvFrR4smwOG6r69ygrKqGqu_dYvVt7-dKmnGYxMI/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1LYSBJssEe275cGvnHA0ovSigvOUIOYhhbPcpozGNWuQ/copy" target="_blank">Class Bar Graph - Lesson 1B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1CFhfZbjd819hDBcPD2xJl8vwGl-lLGj0Mym7qNPQaE0/copy" target="_blank">4LNG - Observations of Light Chart and Class Statement - Lesson 1D</a></li>
          <li><a href="https://docs.google.com/presentation/d/181lWTKyTgAftb0ypt-YqRY7lK4P7na3vlMcqxY36aPM/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1PbnrZD1k7dI0pM6fT7h_sju_ydev5F0t-HG4Syal7CQ/copy" target="_blank">Class Guidelines for Critiquing</a></li>
          <li><a href="https://docs.google.com/presentation/d/17x9wCjiop2pDc96LZb7yZiQ5p9bofLWj97GLgWiyxYQ/copy" target="_blank">Mountain Lion/Rabbit Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Lze2cd9xtauBITdFd0ryRZGZge6fYglfEH7zuOTY59o/copy" target="_blank">Animals' Eyes Cards - Matching</a></li>
          <li><a href="https://docs.google.com/presentation/d/1gA6Llq-IIMkLvXPj620tfmZ1fXAw5A1aii0R-OYc6Ws/copy" target="_blank">Schoolyard Habitat Observation Log</a></li>
          <li><a href="https://docs.google.com/presentation/d/1pOG2OjnkT6YZ1f5JsIFSgLvBWsr7kLt8F24iPkCKPK0/copy" target="_blank">Word Sort Cards - Lesson 4C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1jNqMgF2KczgZQ79i7lARtCY8SMZS1KPNSVsYlapjUHI/copy" target="_blank">Word Sort Cards - Lesson 5B</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
        
      </div>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
